// El refresco de fondo de una bandeja de alertas mientras alguna línea se recalcula (card Fnvibexi).
import {useEffect, useMemo, useState} from 'react';
import {RECALCULATION_REFRESH_MS, recalculationDeadline} from './recalculation';

/**
 * Refresca la bandeja cada `RECALCULATION_REFRESH_MS` mientras alguna fila se recalcula, sólo con la pestaña
 * visible, y para en el tope o al desmontar. `refresh` tiene que ser estable (`useCallback`) y CALLADO: un
 * refresco de fondo que falla conserva lo que había, sin un toast cada 15 s (/ux 04/11).
 *
 * Al llegar al tope vuelve a dibujar la pantalla, para que «Recalculando…» se vaya aunque no llegue nada nuevo.
 */
export function useRecalculationRefresh(items, refresh) {
    const [, setTick] = useState(0);
    const deadline = useMemo(() => recalculationDeadline(items), [items]);

    useEffect(() => {
        if (deadline === null) return undefined;
        const visible = () => typeof document === 'undefined' || document.visibilityState !== 'hidden';
        const interval = setInterval(() => {
            if (Date.now() >= deadline) {
                clearInterval(interval);
                return;
            }
            if (visible()) refresh();
        }, RECALCULATION_REFRESH_MS);
        // Al volver a la pestaña no se espera al próximo turno.
        const onVisibility = () => {
            if (visible() && Date.now() < deadline) refresh();
        };
        document.addEventListener('visibilitychange', onVisibility);
        const expiry = setTimeout(() => setTick((tick) => tick + 1), Math.max(0, deadline - Date.now()) + 50);
        return () => {
            clearInterval(interval);
            clearTimeout(expiry);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, [deadline, refresh]);
}
